module.exports = __webpack_public_path__ + "group_buy/groupbuy_6668-136bca646d585c27aade858fe6dcc3fe.png";